<!-- src/views/DashboardView.vue -->

<template>
  <!--begin::Content wrapper-->
  <div
    dir="rtl"
    class="modal fade"
    id="payments-modal"
    tabindex="-1"
    role="dialog"
    ref="paymentModal"
    aria-labelledby="exampleModalCenterTitle"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-lg modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title" id="exampleModalLongTitle">
            إختر وسيلة الدفع
          </h5>
        </div>
        <div class="modal-body">
          <div class="card">
            <div class="text-center">
                <img width="100px" src="@/assets/wallet.png"/>
                <h5
              class="card-header bg-transparent border-bottom mt-0"
            >
              إشحن محفظتك
            </h5>
           
            </div>

            <div class="card-body">
              <h4 class="card-title font-size-16 mt-0 text-right">
                إختر وسيلة الدفع أدناه وإتبع الخطوات للشحن
              </h4>
              <div class="row">
                <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4">
                  <div
                    class="card payment-box charge-online"
                    data-bs-toggle="modal"
                     @click="hideModal"
                    data-bs-target="#online-modal"
                  >
                    <div class="card-body p-2">
                      <div>
                        <div class="icons-lg mb-1">
                          <span class="uim-svg" style="text-align: center">
                            <div calss="text-center">
                              <img
                                src="assets/img/sadad.png"
                                alt=""
                                style="
                                  width: 80px;
                                  height: 80px;
                                  margin: 0 auto;
                                "
                                class="img-fluid text-center"
                              />
                            </div>
                          </span>
                        </div>
                        <div>
                          <h5
                            class="font-size-13 text-uppercase font-weight-bold text-center"
                          >
                            Sadad | سداد
                          </h5>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4">
                  <div
                    class="card payment-box"
                    data-bs-toggle="modal"
                    @click="hideModal()"
                    data-bs-target="#academia-modal"
                  >
                    <div class="card-body p-2">
                      <div>
                        <div class="icons-lg mb-1">
                          <span class="uim-svg" style="text-align: center">
                            <div calss="text-center">
                              <img
                                src="assets/img/acad-icon.png"
                                alt=""
                                style="
                                  width: 80px;
                                  height: 83px;

                                  margin: 0 auto;
                                "
                                class="img-fluid text-center pt-2"
                              />
                            </div>
                          </span>
                        </div>
                        <div>
                          <h5
                            class="font-size-13 text-uppercase font-weight-bold text-center"
                          >
                            بطاقة Academia
                          </h5>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4">
                  <div
                    class="card payment-box charge-online"
                    data-bs-toggle="modal"
                    @click="hideModal"
                    data-bs-target="#online-modal"
                  >
                    <div class="card-body p-2">
                      <div>
                        <div class="icons-lg mb-1">
                          <span class="uim-svg" style="text-align: center">
                            <div calss="text-center">
                              <img
                                src="assets/img/moamalat.jpeg"
                                alt=""
                                style="
                                  width: 125px;
                                  height: 80px;
                                  margin: 0 auto;
                                "
                                class="img-fluid text-center"
                              />
                            </div>
                          </span>
                        </div>
                        <div>
                          <h5
                            class="font-size-13 text-uppercase font-weight-bold text-center"
                          >
                            البطاقة المصرفية
                          </h5>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4">
                  <div
                    class="card payment-box charge-online"
                    data-bs-toggle="modal"
                     @click="hideModal"
                    data-bs-target="#online-modal"
                  >
                    <div class="card-body p-2">
                      <div>
                        <div class="icons-lg mb-1">
                          <span class="uim-svg" style="text-align: center">
                            <div calss="text-center">
                              <img
                                src="assets/img/mobicash.png"
                                alt=""
                                style="
                                  width: 80px;
                                  height: 80px;
                                  margin: 0 auto;
                                "
                                class="img-fluid text-center"
                              />
                            </div>
                          </span>
                        </div>
                        <div>
                          <h5
                            class="font-size-13 text-uppercase font-weight-bold text-center"
                          >
                            Mobicash | موبي كاش
                          </h5>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4">
                  <div
                    class="card payment-box"
                    data-bs-toggle="modal"
                     @click="hideModal"
                    data-bs-target="#icash-modal"
                  >
                    <div class="card-body p-2">
                      <div>
                        <div class="icons-lg mb-1">
                          <span class="uim-svg" style="text-align: center">
                            <div calss="text-center">
                              <img
                                src="assets/img/icash.png"
                                alt=""
                                style="
                                  width: 140px;
                                  height: 70px;
                                  margin: 0 auto;
                                "
                                class="img-fluid text-center"
                              />
                            </div>
                          </span>
                        </div>
                        <div>
                          <h5
                            class="font-size-13 text-uppercase font-weight-bold text-center"
                          >
                            iCash | أي كاش
                          </h5>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4">
                  <div
                    class="card payment-box charge-online"
                    data-bs-toggle="modal"
                     @click="hideModal"
                    data-bs-target="#online-modal"
                  >
                    <div class="card-body p-2">
                      <div>
                        <div class="icons-lg mb-1">
                          <span class="uim-svg" style="text-align: center">
                            <div calss="text-center">
                              <img
                                src="assets/img/tadawel-new.png"
                                alt=""
                                style="
                                  width: 125px;
                                  height: 68px;
                                  margin: 0 auto;
                                "
                                class="img-fluid text-center"
                              />
                            </div>
                          </span>
                        </div>
                        <div>
                          <h5
                            class="font-size-13 text-uppercase font-weight-bold text-center"
                          >
                            تداول
                          </h5>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4">
                  <div
                    class="card payment-box charge-online"
                    data-bs-toggle="modal"
                     @click="hideModal"
                    data-bs-target="#online-modal"
                  >
                    <div class="card-body p-2">
                      <div>
                        <div class="icons-lg mb-1">
                          <span class="uim-svg" style="text-align: center">
                            <div calss="text-center">
                              <img
                                src="assets/img/edfali.jpeg"
                                alt=""
                                style="
                                  width: 91px;
                                  height: 63px;
                                  margin: 0 auto;
                                "
                                class="img-fluid text-center"
                              />
                            </div>
                          </span>
                        </div>
                        <div>
                          <h5
                            class="font-size-13 text-uppercase font-weight-bold text-center"
                          >
                            إدفع لي
                          </h5>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4">
                  <div class="card payment-box"
                  data-bs-toggle="modal"
                  @click="hideModal()"
                  data-bs-target="#stripe-modal">
                    <div class="card-body p-2">
                      <div>
                        <div class="icons-lg mb-1">
                          <span class="uim-svg" style="text-align: center">
                            <div calss="text-center">
                              <img
                                src="assets/img/visa.png"
                                alt=""
                                style="
                                  width: 80px;
                                  height: 40px;
                                  margin: 0 auto;
                                "
                                class="img-fluid text-center pt-2"
                              />
                            </div>
                          </span>
                        </div>
                        <div>
                          <h5
                            class="font-size-13 text-uppercase font-weight-bold text-center"
                          >
                            Visa Card
                          </h5>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-xl-4 col-lg-4 col-md-4 col-sm-4">
                  <div class="card payment-box"
                  data-bs-toggle="modal"
                  @click="hideModal()"
                  data-bs-target="#stripe-modal">
                    <div class="card-body p-2">
                      <div>
                        <div class="icons-lg mb-1">
                          <span class="uim-svg" style="text-align: center">
                            <div calss="text-center">
                              <img
                                src="assets/img/mastercard.png"
                                alt=""
                                style="
                                  width: 80px;
                                  height: 50px;
                                  margin: 0 auto;
                                "
                                class="img-fluid text-center"
                              />
                            </div>
                          </span>
                        </div>
                        <div>
                          <h5
                            class="font-size-13 text-uppercase font-weight-bold text-center"
                          >
                            MasterCard
                          </h5>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">
            تراجع
          </button>
        </div>
      </div>
    </div>
  </div>
  <!--end::Content wrapper-->
</template>

<script>
import {
  apiUrl,
  courseImagePath,
  deviceId,
  getBrowserName,
  api_get,
  api,
  instructorImagePath,
} from "@/utils/api"; // Adjust the import path according to your project structure
export default {
  name: "Payments",
  data() {
    return {
      token: localStorage.getItem("access_token"),
      respo: localStorage.getItem("respo"),
    };
  },
  created() {},
  methods: {
    hideModal() {
        //$("#payments-modal").modal('hide'); // Then hide it after the DOM is updated
        var myModal = new bootstrap.Modal(document.getElementById('payments-modal'));
        myModal.hide();
        
    },
  },
};
</script>

<style scoped>
.courses-header {
  padding: 10px;
  min-height: 20px;
  background-color: #ddd;
  cursor: pointer;
}
.courses-header:hover {
  background-color: #eafff3;
}
.symbol.symbol-60px.symbol-2by3 .symbol-label {
  width: 60px;
}
</style>
